<template>
  <fragment>
    <AppBody
      title="Relatórios Analíticos"
      :subtitle="reportSubtitle"
      :actions="actions"
      :primaryLoading="exportCSVLoading"
      :secondaryLoading="exportPDFLoading"
      disableDivider
    >
      <CardModule untitle>
        <v-row>
          <v-col class="custom-chip-group">
            <v-chip-group
              :column="mdAndUp"
              :show-arrows="!mdAndUp"
              v-model="tab"
              mandatory
            >
              <v-chip
                v-for="(item, index) in tabInfo"
                :key="index"
                class="custom-chip mr-4"
                color="#E9E8ED"
                active-class="primary active-class"
              >
                {{ item.title }}
              </v-chip>
            </v-chip-group>
          </v-col>
        </v-row>

        <v-tabs-items v-model="tab" touchless style="overflow: visible">
          <v-tab-item v-for="(item, index) in tabInfo" :key="index">
            <component :is="item.component"></component>
          </v-tab-item>
        </v-tabs-items>
      </CardModule>
    </AppBody>
  </fragment>
</template>
<script>
import displayHelpers from "@/mixins/breakpoints.mixins";

import CardModule from "@/components/cards/CardModule.vue";
import AppBody from "@/layouts/components/AppBody.vue";

import General from "@/components/relatorios/General.vue";
import SalesByTicket from "@/components/relatorios/SalesByTicket.vue";
import SalesByDay from "@/components/relatorios/SalesByDay.vue";
import SalesByEvent from "@/components/relatorios/SalesByEvent.vue";
import SalesByChannel from "@/components/relatorios/SalesByChannel.vue";
import SalesByPaymentMethod from "@/components/relatorios/SalesByPaymentMethod.vue";
import PackageEmission from "@/components/relatorios/PackageEmission.vue";
import SalesByPointOfSale from "@/components/relatorios/SalesByPointOfSale.vue";
import DiscountCoupon from "@/components/relatorios/DiscountCoupon.vue";
import Cancellation from "@/components/relatorios/Cancellation.vue";
import Affiliate from "@/components/relatorios/Affiliate.vue";

import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "GeneralAnalytical",
  mixins: [displayHelpers],
  metaInfo() {
    const title = this.$t("reports.detailed-sale");
    return {
      title: `${title} | ElevenTickets`,
      meta: [
        {
          property: "og:title",
          content: `${title} | ElevenTickets`,
        },
      ],
    };
  },
  props: {},
  components: {
    CardModule,
    AppBody,
    General,
    SalesByTicket,
    SalesByDay,
    SalesByEvent,
    SalesByChannel,
    SalesByPaymentMethod,
    PackageEmission,
    SalesByPointOfSale,
    DiscountCoupon,
    Cancellation,
    Affiliate,
  },
  data() {
    return {
      showFinancialReport: false,
      filter: {
        dateInterval: "",
        rangeDates: [],
      },
      actions: [
        {
          id: "CSV",
          name: "",
          icon: "mdi-microsoft-excel",
          action: () => this.exportCSV(),
        },
        {
          id: "PDF",
          name: "",
          icon: "mdi-file-pdf-box",
          action: () => this.exportPDF(),
        },
      ],
      tab: 0,
    };
  },
  methods: {
    ...mapActions([
      "fetchDetailedSalesByEvent",
      "exportDetailedSalesByEventPDF",
      "exportDetailedSalesByEventCSV",
      "exportSalesByTicketPDF",
      "exportSalesByTicketCSV",
      "exportSalesByDayPDF",
      "exportSalesByDayCSV",
      "exportSalesByEventPDF",
      "exportSalesByEventCSV",
      "exportSalesByChannelPDF",
      "exportSalesByChannelCSV",
      "exportSalesByPointOfSalePDF",
      "exportSalesByPointOfSaleCSV",
      "exportPaymentMethodPDF",
      "exportPaymentMethodCSV",
      "exportSendingPackagesPDF",
      "exportSendingPackagesCSV",
      "exportDiscountCouponPDF",
      "exportDiscountCouponCSV",
      "exportCancellationPDF",
      "exportCancellationCSV",
      "exportReceivablesPDF",
      "exportReceivablesCSV",
      "exportAffiliatesCSV",
      "exportAffiliatesPDF",
    ]),
    ...mapMutations([
      "setReportsFilter",
      "setDetailedSalesByEvent",
      "setSalesByDay",
      "setSalesByChannel",
      "setSalesByPointOfSale",
      "setCancellation",
    ]),
    exportPDF() {
      switch (this.tab) {
        case 0:
          this.exportDetailedSalesByEventPDF(this.reportsFilter);
          break;
        case 1:
          this.exportSalesByDayPDF(this.reportsFilter);
          break;
        case 2:
          this.exportSalesByEventPDF(this.reportsFilter);
          break;
        case 3:
          this.exportAffiliatesPDF(this.reportsFilter);
          break;
        case 4:
          this.exportSalesByChannelPDF(this.reportsFilter);
          break;
        case 5:
          this.exportSalesByPointOfSalePDF(this.reportsFilter);
          break;
        case 6:
          this.exportPaymentMethodPDF(this.reportsFilter);
          break;
        case 7:
          this.exportSendingPackagesPDF(this.reportsFilter);
          break;
        case 8:
          this.exportDiscountCouponPDF(this.reportsFilter);
          break;
        case 9:
          this.exportCancellationPDF(this.reportsFilter);
          break;
        case 10:
          this.exportSalesByTicketPDF(this.reportsFilter);
          break;
      }
    },
    exportCSV() {
      switch (this.tab) {
        case 0:
          this.exportDetailedSalesByEventCSV(this.reportsFilter);
          break;
        case 1:
          this.exportSalesByDayCSV(this.reportsFilter);
          break;
        case 2:
          this.exportSalesByEventCSV(this.reportsFilter);
          break;
        case 3:
          this.exportAffiliatesCSV(this.reportsFilter);
          break;
        case 4:
          this.exportSalesByChannelCSV(this.reportsFilter);
          break;
        case 5:
          this.exportSalesByPointOfSaleCSV(this.reportsFilter);
          break;
        case 6:
          this.exportPaymentMethodCSV(this.reportsFilter);
          break;
        case 7:
          this.exportSendingPackagesCSV(this.reportsFilter);
          break;
        case 8:
          this.exportDiscountCouponCSV(this.reportsFilter);
          break;
        case 9:
          this.exportCancellationCSV(this.reportsFilter);
          break;
        case 10:
          this.exportSalesByTicketCSV(this.reportsFilter);
          break;
      }
    },
  },
  computed: {
    ...mapGetters([
      "storeSequencial",
      "exportCSVLoading",
      "exportPDFLoading",
      "reportsFilter",
      "isAdmin",
    ]),
    tabInfo() {
      return [
        {
          title: this.$t("reports.general-sales.title"),
          component: General,
        },

        {
          title: this.$t("reports.sales-by-day.title"),
          component: SalesByDay,
        },
        {
          title: this.$t("reports.sales-by-event.title"),
          component: SalesByEvent,
        },
        {
          title: this.$t("reports.sales-by-affiliate.title"),
          component: Affiliate,
        },
        {
          title: this.$t("reports.channel-sales.title"),
          component: SalesByChannel,
        },
        {
          title: this.$t("reports.point-of-sale.title"),
          component: SalesByPointOfSale,
        },
        {
          title: this.$t("reports.payment-method.title"),
          component: SalesByPaymentMethod,
        },
        {
          title: this.$t("reports.package-emission.title"),
          component: PackageEmission,
        },
        {
          title: this.$t("reports.sales-by-coupon.title"),
          component: DiscountCoupon,
        },
        {
          title: this.$t("reports.cancellation.title"),
          component: Cancellation,
        },
        {
          title: this.$t("reports.product-type.title"),
          component: SalesByTicket,
        },
      ];
    },
    reportSubtitle() {
      switch (this.tab) {
        case 0:
          return this.$t("reports.general-sales.title");
        case 1:
          return this.$t("reports.sales-by-day.title");
        case 2:
          return this.$t("reports.sales-by-event.title");
        case 3:
          return this.$t("reports.sales-by-affiliate.title");
        case 4:
          return this.$t("reports.channel-sales.title");
        case 5:
          return this.$t("reports.point-of-sale.title");
        case 6:
          return this.$t("reports.payment-method.title");
        case 7:
          return this.$t("reports.package-emission.title");
        case 8:
          return this.$t("reports.sales-by-coupon.title");
        case 9:
          return this.$t("reports.cancellation.title");
        case 10:
          return this.$t("reports.product-type.title");
      }
      return this.$t("reports.title");
    },
  },
  watch: {
    tab() {
      this.setReportsFilter({ producerId: this.storeSequencial });
    },
  },
  destroyed() {
    this.setDetailedSalesByEvent({ info: [], totals: [] });
    this.setSalesByDay({ info: [], totals: [] });
    this.setSalesByChannel({ info: [], totals: [] });
    this.setSalesByPointOfSale({ info: [], totals: [] });
    this.setCancellation({ info: [], totals: [] });
  },
};
</script>
<style scoped>
.custom-chip {
  font-size: 1rem;
  transition: none;
}

.custom-chip:hover {
  box-shadow: inset 0px 0px 0px 1px #cbcbcb;
}

.active-class {
  color: #f2f2f2 !important;
}

.active-class:hover {
  box-shadow: none;
}

.v-chip-group--column >>> .v-slide-group__content {
  display: flex;
  justify-content: center;
}
</style>
